import React, { useState, useEffect } from "react";
import { db } from "../../services/firebaseConfig";
import { collection, query, where, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../styles/UserList.css";

const UserList = ({ currentRole, currentUserId }) => {
    const [users, setUsers] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [branches, setBranches] = useState({});
    const [passwordVisibility, setPasswordVisibility] = useState({});
    const [editingUser, setEditingUser] = useState(null);
    const [editFormData, setEditFormData] = useState({});

    useEffect(() => {
        if (!db || !currentRole) return;

        const usersCollection = collection(db, "inventori", "selangor", "users");
        let userQuery;

        if (currentRole === "pengarah") {
            userQuery = query(usersCollection, where("role", "==", "pengerusi"));
        } else if (currentRole === "pengerusi") {
            if (!currentUserId) return;
            userQuery = query(usersCollection, where("createdBy", "==", currentUserId));
        }
        if (!userQuery) return;

        const unsubscribe = onSnapshot(userQuery, (snapshot) => {
            const usersList = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setUsers(usersList);

            if (currentRole === "pengarah") {
                snapshot.docs.forEach((doc) => {
                    const pengurusQuery = query(usersCollection, where("createdBy", "==", doc.id));
                    onSnapshot(pengurusQuery, (pengurusSnapshot) => {
                        const pengurusList = pengurusSnapshot.docs.map((pengurusDoc) => ({ id: pengurusDoc.id, ...pengurusDoc.data() }));
                        setBranches((prev) => ({ ...prev, [doc.id]: pengurusList }));
                    });
                });
            }
        });

        return () => unsubscribe();
    }, [currentRole, currentUserId]);

    const handleToggle = (userId) => {
        setExpanded((prev) => (prev === userId ? null : userId));
    };

    const togglePasswordVisibility = (userId) => {
        setPasswordVisibility((prev) => ({ ...prev, [userId]: !prev[userId] }));
    };

    const handleEditUser = (user) => {
        setEditingUser(user.id);
        setEditFormData(user);
    };

    const handleCancelEdit = () => {
        setEditingUser(null);
        setEditFormData({});
    };

    const handleInputChange = (e) => {
        setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
    };

    const handleSaveEdit = async () => {
        if (!editingUser) return;

        const userRef = doc(db, "inventori", "selangor", "users", editingUser);

        // Elak tersimpan 'id' sebagai field dalam dokumen
        const { id, ...toSave } = editFormData;

        // (Pilihan) kemas whitespace nama cawangan
        if (typeof toSave.branchName === "string") {
            toSave.branchName = toSave.branchName.trim();
        }
        await updateDoc(userRef, editFormData);

        setEditingUser(null);
        setEditFormData({});
    };

    return (
        <div className="user-list-container">
            <h2>{currentRole === "pengarah" ? "Senarai Semua Pengguna" : "Senarai Pengurus Cawangan"}</h2>
            <ul className="user-list">
                {users.map((user) => (
                    <li key={user.id} className="user-item">
                        {/* ✅ Jika pengerusi, terus papar & boleh edit */}
                        {currentRole === "pengerusi" ? (
                            <>
                                <div className="user-header">
                                    <strong>{user.branchName || "Cawangan Tidak Bernama"}</strong> {/* 🔥 Branch Name sebagai tajuk */}
                                </div>
                                <div className="user-details">
                                    {editingUser === user.id ? (
                                        <>
                                            <label>Nama PASTI / Cawangan:</label>
                                            <input
                                                type="text"
                                                name="branchName"
                                                value={editFormData.branchName || ""}
                                                onChange={handleInputChange}
                                            />

                                            <label>Nama:</label>
                                            <input type="text" name="name" value={editFormData.name || ""} onChange={handleInputChange} />

                                            <label>No Telefon:</label>
                                            <input type="tel" name="phone" value={editFormData.phone || ""} onChange={handleInputChange} />

                                            <label>Kata Laluan:</label>
                                            <input type="text" name="password" value={editFormData.password || ""} onChange={handleInputChange} />

                                            <button className="save-button" onClick={handleSaveEdit}>Simpan</button>
                                            <button className="cancel-button" onClick={handleCancelEdit}>Batal</button>
                                        </>
                                    ) : (
                                        <>
                                            <p>Nama: {user.name || "N/A"}</p>
                                            <p>No Telefon: {user.phone || "Tiada Telefon"}</p>
                                            <p>Kata Laluan: {passwordVisibility[user.id] ? user.password : "****"}
                                                <button
                                                    className="toggle-password"
                                                    onClick={() => togglePasswordVisibility(user.id)}
                                                >
                                                    <FontAwesomeIcon icon={passwordVisibility[user.id] ? faEyeSlash : faEye} />
                                                </button>
                                            </p>
                                            <button className="edit-button" onClick={() => handleEditUser(user)}>Edit</button>
                                        </>
                                    )}
                                </div></>
                        ) : (
                            <>
                                {/* ✅ Jika pengarah, boleh expand */}
                                <div className="user-header" onClick={() => handleToggle(user.id)}>
                                    <span className="user-name">{user.district || user.branchName || "Tidak Diketahui"}</span>
                                    <button className="expand-button">{expanded === user.id ? "▲" : "▼"}</button>
                                </div>
                                {expanded === user.id && (
                                    <div className="user-details">
                                        {editingUser === user.id ? (
                                            <>
                                                <label>Nama:</label>
                                                <input type="text" name="name" value={editFormData.name || ""} onChange={handleInputChange} />

                                                <label>No Telefon:</label>
                                                <input type="tel" name="phone" value={editFormData.phone || ""} onChange={handleInputChange} />

                                                <label>Kawasan:</label>
                                                <input type="text" name="district" value={editFormData.district || ""} onChange={handleInputChange} />

                                                <label>Kata Laluan:</label>
                                                <input type="text" name="password" value={editFormData.password || ""} onChange={handleInputChange} />

                                                <button className="save-button" onClick={handleSaveEdit}>Simpan</button>
                                                <button className="cancel-button" onClick={handleCancelEdit}>Batal</button>
                                            </>
                                        ) : (
                                            <>
                                                <p>Nama: {user.name || "N/A"}</p>
                                                <p>No Telefon: {user.phone || "Tiada Telefon"}</p>
                                                <p>Kata Laluan: {passwordVisibility[user.id] ? user.password : "****"}
                                                    <button className="toggle-password" onClick={() => togglePasswordVisibility(user.id)}>
                                                        {passwordVisibility[user.id] ? "🙈" : "👁"}
                                                    </button>
                                                </p>
                                                <button className="edit-button" onClick={() => handleEditUser(user)}>Edit</button>
                                            </>
                                        )}
                                    </div>
                                )}

                                {currentRole === "pengarah" && branches[user.id] && (
                                    <div className="branch-list">
                                        <strong>Bilangan Cawangan: {branches[user.id].length}</strong>
                                        <ul>
                                            {branches[user.id].map((branch) => (
                                                <li key={branch.id}>{branch.branchName || "Cawangan Tidak Bernama"}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}
                    </li>
                ))}
            </ul>



        </div>
    );
};

export default UserList;
